<template>
  <div>
    <v-row v-if="trip">
      <v-col cols="12" sm="2" md="2" lg="2">
        <v-img
          v-if="trip.vehicle"
          :src="trip.vehicle.pic"
          height="60"
          width="80"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <v-row v-if="!trip.vehicle || !trip.vehicle.marketVeh">
          <z-vehicle-select
            :value="trip.vehicle"
            :bodyType="trip.bodyType"
            :truckType="trip.truckType"
            :label="$i18n.t('Vehicle')"
            @input="onVehicleChange"
            :disabled="!trip.showVehicleAssign"
          />
        </v-row>

        <v-row
          v-if="trip.vehicle && trip.vehicle.marketVeh"
          style="
            align-self: center;
            height: 37px;
            border: 1px solid #d9d9d9;
            border-radius: 7px;
            align-content: space-evenly;
            margin-bottom: 10px;
            background: #f6f6f6;
          "
        >
          <v-col cols="12" sm="4" md="4" lg="4" v-if="trip.vehicle">{{
            trip.vehicle.regNo
          }}</v-col>
          <v-col cols="12" sm="6" md="6" lg="6" v-if="trip.vehicle">{{
            trip.vehicle.truckTypeStr
          }}</v-col>
        </v-row>

        <v-row>
          <v-chip
            small
            color="green"
            dark
            v-if="
              trip.vehicle != null &&
              trip.vehicle.corp_id &&
              !trip.vehicle.marketVeh &&
              trip.vendor_id != trip.vehicle.corp_id
            "
            >{{ $i18n.t("Supplier Vehicle") }} -
            {{ trip.vehicle.corpName }}
          </v-chip>
          <v-chip
            small
            color="cyan"
            dark
            v-if="
              trip.vehicle != null &&
              !trip.vehicle.marketVeh &&
              trip.vendor_id == trip.vehicle.corp_id
            "
            >{{ $i18n.t("Own Vehicle") }}
          </v-chip>
          <v-chip
            small
            color="cyan"
            dark
            v-if="trip.vehicle != null && trip.vehicle.marketVeh"
            >{{ $i18n.t("Market Vehicle")
            }}{{
              trip.vehicle.ownerInfo && trip.vehicle.ownerInfo.name
                ? " - " + trip.vehicle.ownerInfo.name
                : ""
            }}
          </v-chip>
          <v-spacer></v-spacer>
          <a v-if="trip.vehicle && trip.vehicle.ownerInfo" @click="showAddInfo = !showAddInfo">{{ !showAddInfo ? $i18n.t("Additional Info") : $i18n.t("Hide Info")}}</a>
          <br>
          <span v-if="trip.vehicle && trip.vehicle.ownerInfo && showAddInfo">
            {{$i18n.t("Owner")}} : {{trip.vehicle.ownerInfo.name}}
            <br v-if="trip.vehicle.ownerInfo.name">
            {{$i18n.t("PAN")}} : {{trip.vehicle.ownerInfo.pan}}
            <br v-if="trip.vehicle.ownerInfo.contactPerson.name">
            {{$i18n.t("Contact Person")}} : {{trip.vehicle.ownerInfo.contactPerson.name}}
            <br v-if="trip.vehicle.ownerInfo.contactPerson.email">
            {{$i18n.t("Email")}} : {{trip.vehicle.ownerInfo.contactPerson.email}}
            <br v-if="trip.vehicle.ownerInfo.contactPerson.phone">
            {{$i18n.t("Phone")}} : {{trip.vehicle.ownerInfo.contactPerson.countryCode}} {{trip.vehicle.ownerInfo.contactPerson.phone}}
          </span>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        :class="trip.vehicle && !trip.vehicle.marketVeh ? 'px-10 py-5' : 'px-10'"
        sm="4"
        md="4"
        lg="4"
      >
        <v-row>
          <v-btn
            x-small
            fab
            color="blue lighten-1"
            v-if="trip.showVehicleAssign && trip.vehicle && trip.vehicle.marketVeh"
            @click="vehicleCreateDialog = true"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
          <v-tooltip
            top
            v-if="trip.showVehicleAssign && trip.vehicle && trip.vehicle.regNo"
          >
            <template v-slot:activator="{ tooltip }">
              <z-confirm-button
                @click="unassignVehicle(trip)"
                fab
                x-small
                color="error lighten-1"
                v-on="tooltip"
                :message="$i18n.t('Are you sure you want to unassign vehicle?')"
              >
                <v-icon>mdi-close</v-icon>
              </z-confirm-button>
            </template>
            <span>{{ $i18n.t("Unassign Vehicle") }}</span>
          </v-tooltip>
          <v-btn
            x-small
            fab
            color="blue lighten-1"
            v-if="trip.showVehicleAssign"
            @click="showAddNewVehicle"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>

    <z-vehicle-create
      @select="select"
      :bodyType="bodyType"
      :truckType="truckType"
      :showDialog="vehicleCreateDialog"
      :showGrid1="trip.showVehicleAssign"
    ></z-vehicle-create>

    <z-vehicle-create-form
      :trip_id="trip._id"
      :bodyType="bodyType"
      :truckType="truckType"
      :owner_id="vehicleSupplier_id"
      :vehicleCreateDialog="vehicleCreateFormDialog"
      @closeVehicleCreateDialog="closeVehicleCreateFormDialog"
      @setAdhocVehicle="setVehicleData"
    >
    </z-vehicle-create-form>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "Vehicle",
  props: {
    trip: {
      default: null,
    },
    bodyType: {
      default: null,
    },
    truckType: {
      default: null,
    },
    owner_id: {
      default: null,
    },
  },
})
export default class Vehicle extends (Vue, Themeable) {
  dialog = false;
  vehicleCreateFormDialog = null;
  vehicleSupplier_id = null;
  vehicleCreateDialog = null;
  showAddInfo = null;

  onVehicleChange(newVal) {
    this.$emit("input", newVal);
  }

  select(vehicle) {
    this.vehicleCreateDialog = false;
    if (vehicle) {
      this.$emit("setAdhocVehicle", vehicle);
    }
  }

  unassignVehicle() {
    this.$emit("unassignVehicle", this.trip);
  }

  closeVehicleCreateFormDialog() {
    this.vehicleCreateFormDialog = null;
    this.vehicleCreateDialog = null;
  }

  setVehicleData(vehicle) {
    this.$emit("setAdhocVehicle", vehicle);
  }

  showAddNewVehicle() {
    if (this.trip && this.trip.billings) {
      for (let _i = 0; _i < this.trip.billings.length; _i++) {
        if (this.trip.billings[_i].client_id != this.trip.corp_id) {
          this.vehicleSupplier_id = this.trip.billings[_i].vendor_id;
        }
      }
    }
    if (
      !this.vehicleSupplier_id &&
      this.trip &&
      this.trip.driver &&
      this.trip.driver.driverOf &&
      this.trip.driver.driverOf != this.trip.myCorp_id
    ) {
      this.vehicleSupplier_id = this.trip.driver.driverOf;
    }
    this.vehicleCreateFormDialog = null;
    this.vehicleCreateFormDialog = true;
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
.v-dialog > .v-card > .v-card__text {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-card .v-card__actions {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-dialog .v-card .v-card__title {
  padding-top: 10px;
}
.actionBox {
  position: sticky;
  background: white;
  bottom: 0px;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-top: 1px solid #dfdfdf;
  padding: 10px;
}
</style>
